import { render, staticRenderFns } from "./dlrz.vue?vue&type=template&id=05f5238e&scoped=true&"
import script from "./dlrz.vue?vue&type=script&lang=js&"
export * from "./dlrz.vue?vue&type=script&lang=js&"
import style0 from "./dlrz.vue?vue&type=style&index=0&id=05f5238e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f5238e",
  null
  
)

export default component.exports